import React from 'react'
import ButtonSquare from './ButtonSquare.jsx'

export default function ButtonCircle(props) {
    const {
        onClick = () => false,
        href = '',
        icon = '',
        text = '',
        tooltip = false,
        tooltipText = '',
        addClass='',
        part = false,
        jsnav = true
    } = props
    return (
        <ButtonSquare
            onClick={onClick}
            href={href}
            icon={icon}
            text={text}
            tooltip={tooltip}
            tooltipText={tooltipText}
            addClass={addClass+' rounded-circle'}
            part={part}
            jsnav={jsnav}
        >
            {icon} {text}
        </ButtonSquare>
    );
}